import axios from 'axios';

const api0ApiBaseURL = 'https://svod.polyanaski.ru/api0';
const api0Api = axios.create({
    baseURL: api0ApiBaseURL
});

export {api0ApiBaseURL, api0Api};